<template>
  <v-layout row justify-center>
    <!-- <v-btn @click="newPropietario('4252302XH6045S0004WB')">Borrar</v-btn> -->
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card v-if="datos">
        <v-toolbar dark color="success">
          <v-btn icon dark @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Datos del inmueble ({{ refCat }})</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <!-- <v-btn dark flat @click="dialog = false">Guardar</v-btn> -->
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text v-if="debug">
          <pre>Firmas: {{firmas}}</pre>
          <pre>Link Firma: {{ `${ruta}/firma/${getUserUid}?cp=${getUserUid}` }}</pre>
          <!-- http://localhost:8080/firma/OCR-MlUyeDUzOS0xNTUwMjM3NDU2NjM0 -->
        </v-card-text>
        <v-card-text>
          <v-container fluid grid-list-md>
            <!-- Datos Inmueble -->
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
                <v-flex xs12>
                  <span class="blue--text body-1">Dirección:</span>
                </v-flex>
                <v-layout wrap>
                  <v-flex xs12>
                    <span class="grey--text">{{ formatedInmueble.l1 }}</span>
                  </v-flex>
                  <v-flex xs12>
                    <span class="grey--text">{{ formatedInmueble.l2 }}</span>
                  </v-flex>
                  <v-flex xs12>
                    <span class="grey--text">{{ formatedInmueble.l3 }}</span>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-text-field label="Escalera" v-model="datos.inmuebleData.escalera"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-text-field label="Piso" v-model="datos.inmuebleData.piso"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-text-field label="Letra" v-model="datos.inmuebleData.letra"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-flex xs12>
                  <span class="blue--text body-1">Ingresos unidad familiar:</span>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-switch v-model="datos.inmuebleData.iprem3" @change="changeIprem3">
                    <template v-slot:label>
                      ¿Son inferiores a 22.560 EUR anuales?
                    </template>
                  </v-switch>
                </v-flex>
                <v-flex xs12 sm6 v-if="iprem55Visible">
                  <v-switch :disabled="iprem55Disbled" v-model="datos.inmuebleData.iprem55">
                    <template v-slot:label>
                      ¿Son inferiores a 41.360 EUR anuales?
                    </template>
                  </v-switch>
                </v-flex>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-btn color="primary" @click="saveInmueble">Guardar</v-btn>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>

            <!-- Datos Propietarios / inquilinos -->
            <v-layout wrap>
                <v-flex xs12>
                  <span class="blue--text body-1">Propietarios e inquilinos:</span>
                </v-flex>
                <v-flex xs12>
                  <p class="new-user headline grey--text font-weight-thin mt-3" @click="nuevoUsuario">
                    <v-btn
                      color="success"
                      class="white--text boton-edit"
                      fab
                      small
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    Agregar propietario/inquilino
                  </p>
                </v-flex>
                <v-flex xs12>
                  <v-hover
                    v-for="(item, i) in usersFormated" 
                    :key="i">
                    <v-card
                      slot-scope="{ hover }"
                      :class="`mt-3 pointer-card elevation-${hover ? 12 : 2}`"
                      :color="`${hover ? 'amber lighten-5' : 'grey lighten-4'}`"
                    >
                      <v-card-text class="grey--text text--darken-2 font-weight-light">
                        <p class="headline blue--text font-weight-thin mt-3">
                          <!-- Editar o Eliminar sólo si no es el usuario principal -->
                          <v-btn
                            v-if="getUserUid != item.id"
                            color="orange"
                            class="white--text boton-edit"
                            fab
                            small
                            @click.stop="userEdit(item.id)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            v-if="getUserUid != item.id"
                            color="red"
                            class="white--text boton-edit"
                            fab
                            small
                            @click.stop="userDelete(item.id)"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                          {{ i+1 }} : {{ item.nombre }}
                        </p>
                        <!-- <p style="line-height:29px">
                          {{ item.l1 }}<br>
                          {{ item.l2 }}<br>
                          {{ item.l3 }}<br>
                          <strong>Personas empadronadas: 0</strong>
                        </p> -->
                        <v-layout wrap>
                          <v-flex xs12 sm4>
                            <span class="grey--text body-1">Propietario/Inquilino</span>
                            <v-radio-group @change="changePropietario(item.id)" v-model="usuariosInmueble.filter(i => i.id === item.id)[0].data.tipo" row>
                              <v-radio
                                label="Es propietario"
                                value="0"
                              ></v-radio>
                              <v-radio
                                label="Es inquilino"
                                value="1"
                              ></v-radio>
                            </v-radio-group>
                            <v-slider
                              v-if="item.tipo === '0'"
                              label="% Participación:"
                              v-model="usuariosInmueble.filter(i => i.id === item.id)[0].data.cuota"
                              thumb-label="always"
                            >
                            </v-slider>
                            <!-- <v-text-field v-if="item.tipo === '0'" label="Participación" v-model="datos.users.filter(i => i.id === item.id)[0].cuota" prefix="%" maxlength="3" type="number" min="1" max="100"></v-text-field> -->
                          </v-flex>
                          <v-flex xs12 sm3>
                            <span class="grey--text body-1">Empadronado</span>
                            <v-radio-group v-model="usuariosInmueble.filter(i => i.id === item.id)[0].data.empadronado" row>
                              <v-radio
                                label="Si"
                                :value="true"
                              ></v-radio>
                              <v-radio
                                label="No"
                                :value="false"
                              ></v-radio>
                            </v-radio-group>
                          </v-flex>
                          <v-flex xs12 sm3>
                            <p v-if="firma2user(item.id)" class="green--text body-1">Firma guardada</p>
                            <p v-else class="red--text body-1">Pendiente de firma</p>
                            <v-btn @click="gestionarFrima(item.id, item.nombre)">Gestionar firma</v-btn>
                            <!-- <a target="_blank" :href="`${ruta}/firma/${getUserUid}?cp=${item.id}`">Ir al link firma</a> -->
                          </v-flex>
                          <v-flex xs12 sm3>
                            <v-btn color="primary" @click="saveChangeUser(item.id)">Guardar</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-hover>
                </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <Profile v-on:deleteUser="userDelete" :usuario="usuarioSelect" :isNewUser="newUserAdded"  formName="formProfileInmueble"/>

    <!-- Nuevo Usuario -->
    <v-dialog v-model="dialogNewUser" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Agregar Propietario/Inquilino</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <span class="headline font-weight-light blue--text">Opción 1: Agregar un registro existente.</span>
              </v-flex>
              <v-flex xs12>
                <span>Para agregar un registro ya existente, selecciónelo del siguente listado y pulse sobre el botón "Agregar existente"</span>
              </v-flex>
              <v-flex xs12 md8>
                <v-autocomplete
                  v-model="reutilizarCoProp"
                  :items="coPropNotUsedFormat"
                  item-text="text"
                  label="Propietario/Inquilino"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md4>
                <v-btn :disabled="!!!reutilizarCoProp" color="success" @click="reutilizarCoPropFunc(reutilizarCoProp)">Agregar existente</v-btn>
              </v-flex>
            </v-layout>

            <v-divider></v-divider>

            <v-layout wrap class="mt-3">
              <v-flex xs12>
                <span class="headline font-weight-light blue--text">Opción 2: Crear un registro nuevo.</span>
              </v-flex>
              <v-flex xs12 md4>
                <v-btn color="primary" @click="crearCoProp">Crear nuevo</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialogNewUser = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo Confirmación delete -->
    <v-dialog v-model="deleteConfirm.dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ deleteConfirm.title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <span>{{ deleteConfirm.text }}</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="warning" @click="confirmDelete(deleteConfirm.action)">Eliminar</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="confirmDelete('cancel')">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogGestionFirma" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Gestión Firma</span>
        </v-card-title>
        <v-card-text v-if="gestionFirmaData">
          <v-container grid-list-md>
            <v-layout wrap class="grey--text">
              <v-flex xs12>
                <span>
                  Las firmas digitalizadas se utilizarán para firmar los documentos que requiera la Administración correspondiente para la tramitación de las subvenciones.<br>
                  Dichos documentos deberán ser previamente autorizados por usted.
                </span>
              </v-flex>
              <v-flex xs12>
                <p v-if="gestionFirmaData.id === getUserUid">
                  Haga click en el botón<span class="green--text"> verde</span> "Ir al enlace" para enviarnos su firma.
                </p>
                <p v-else>
                  Copie y envíe a {{ gestionFirmaData.nombre }} el link que encontrará más abajo, para que nos envíe su firma.
                </p>
              </v-flex>
            </v-layout>

              <v-divider></v-divider>
            
            <v-layout wrap>
              <v-flex xs12>
                <span>Link para {{ gestionFirmaData.nombre }}: {{ gestionFirmaData.firma2user && gestionFirmaData.firma2user.firma ? '  (ya está firmada)' : '' }}</span>
              </v-flex>
              <v-flex xs12>
                <span class="blue--text" v-if="gestionFirmaData.firma2user && gestionFirmaData.firma2user.isActive">{{ gestionFirmaData.link }}</span>
                <span v-else class="red--text">Primero debe activarlo en el siguiente botón:</span>
              </v-flex>
            </v-layout>

              <v-divider></v-divider>

            <v-layout wrap>
              <template v-if="!gestionFirmaData.firma2user || !gestionFirmaData.firma2user.isActive">
                <v-flex xs12>
                  <v-btn class="primary" @click="changeStatusFirma(gestionFirmaData.id, true)">
                    Activar Firma
                  </v-btn>
                </v-flex>
              </template>
              <template v-else>
                <v-flex xs12>
                  <v-btn class="warning" @click="changeStatusFirma(gestionFirmaData.id, false)">
                    Desactivar Firma
                  </v-btn>
                </v-flex>
                <v-flex xs12>
                  <v-btn class="success" target="_blank" :href="gestionFirmaData.link">Ir al enlace</v-btn>
                </v-flex>
              </template>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <!-- <v-btn color="success">Eliminar</v-btn> -->
          <v-spacer></v-spacer>
          <v-btn @click="dialogGestionFirma = false; gestionFirmaData = null">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Profile from "./edit-profile-inmueble";
import { setTimeout } from 'timers';
export default {
  components: { Profile },
  props: ["inmueble", "usuario", "formatedInmueble"],
  data() {
    return {
      dialog: false,
      debug: false,
      datos: null,
      usuarioSelect: null,
      usuarios: null,
      usuariosInmueble: null,
      dialogNewUser: false,
      newUserAdded: null,
      reutilizarCoProp: null,
      deleteConfirm: {
        dialog: false,
        title: 'Título',
        text: '¿ Texto ?',
        action: 'deleteTalCosa',
        info: null
      },
      dialogGestionFirma: false,
      gestionFirmaData: null
    };
  },
  mounted() {
    // this.usuarios = JSON.parse(JSON.stringify(this.datos.users));
    this.setCoPropietarios();
    this.setFirmas();
  },
  watch: {
    firmas() {
      if (this.gestionFirmaData && this.gestionFirmaData.id) {
        // firma2user: this.firma2user(idx)
        this.gestionFirmaData.firma2user = this.firma2user(this.gestionFirmaData.id);
      }
    },
    dialogInmueble(newValue) {
      console.log("cambio por watch");
      this.dialog = newValue;
    },
    dialogNewUser() {
      this.reutilizarCoProp = null;
    },
    dialog(newValue) {
      if (newValue) {
        this.usuariosInmueble = JSON.parse(JSON.stringify(this.usuariosEnInmueble));
        console.log("abierto diálogo. leer Inmueble...");
        this.datos = Object.assign(
          {},
          this.propietarioInmuebleModel,
          JSON.parse(JSON.stringify(this.inmueble))
        );
        delete this.datos.listInmuebles;
        if (this.datos.direccion.provincia) {
          this.setMunicipios(this.datos.direccion.provincia);
        }
      }
      this.newUserAdded = null;
      this.setPropietarioDialog({
        dialog: "formInmueble",
        value: newValue
      });
    },
    allUsers(newValue) {
      this.usuarios = JSON.parse(JSON.stringify(newValue));
    },
    usuariosEnInmueble(newValue) {
      this.usuariosInmueble = JSON.parse(JSON.stringify(newValue));
    },
    /* totalUsers(newValue) {
      this.usuarios = JSON.parse(JSON.stringify(newValue));
    }, */
    ultimoCoProAgregado(newValue) {
      if (newValue) {
        console.log(`Se ha agregado el coPropietario ${newValue}`);
        this.newUserAdded = newValue;
        this.userEdit(newValue);
      }
    }/* ,
    coPropietariosNum(oldValue, newValue) {
      if (newValue > oldValue) {
        console.log(`Se ha agregado el coPropietario ${this.coPropietarios.id}`);
      }
    } */
    /* totalChangeUsers(newValue) {
      if (newValue) {
        console.log(`guardar cambios en: ${newValue}`);
        this.saveDataInmuebleUser({id: newValue, inmueble: this.refCat, data: this.usuariosInmueble.filter(i => i.id === newValue)[0].data});
      }
    } */
    /* coPropietarios() {
      this.datos.copropietarios = JSON.parse(JSON.stringify(this.coPropietarios));
    } */
  },
  computed: {
    ...mapGetters([
      "getUserUid",
      "getProvinciasSelect",
      "getMunicipiosSelect",
      "propietarioInmuebleModel",
      "dialogInmueble",
      "coPropietarios",
      "ultimoCoProAgregado",
      "getUserUid",
      "allUsers",
      "firmas"
    ]),
    ruta() {
      return window.location.origin;
    },
    iprem55Visible() {
      return this.datos ? this.datos.direccion.ca.code === 'AN' : false;
    },
    iprem55Disbled() {
      return this.datos ? this.datos.inmuebleData.iprem3 : false;
    },
    all() {
      return this.allUsers;
    },
    usuariosEnInmueble() {
      if (!this.inmueble) {
        return [];
      }
      return this.inmueble.users;
    },
    coPropNotUsed() {
      if (!this.coPropietarios || !this.refCat) {
        return [];
      }
      return this.coPropietarios.filter(i => !i.dataUser.inmueblesList.includes(this.refCat));
    },
    coPropNotUsedFormat() {
      if (this.coPropNotUsed.length < 1) {
        return []
      }
      return this.coPropNotUsed.map(i => {
        let ncompleto = `${i.dataUser.nombre} ${i.dataUser.apellido1} ${i.dataUser.apellido2}`.trim();
        if (ncompleto.length < 1) {
          ncompleto = i.id;
        }
        return {
          value: i.id,
          text: ncompleto
        };
      });
    },
    coPropUsed() {
      if (!this.coPropietarios || !this.refCat) {
        return [];
      }
      return this.coPropietarios.filter(i => i.dataUser.inmueblesList.includes(this.refCat));
    },
    refCat() {
      if (!this.datos || !this.datos.inmuebleData) {
        return '';
      }
      return this.datos.inmuebleData.refCat;
    },
    totalUsers() {
      if (!this.datos || !this.datos.users) {
        return null;
      }
      let data = JSON.parse(JSON.stringify(this.datos.users)); // Usuario principal
      if (this.coPropUsed && this.coPropUsed.length > 0) {
        this.coPropUsed.forEach(element => {
          data.push(element);
        });
      }
      return data;
    },
    /* totalChangeUsers() {
      const usr = this.usuariosInmueble;
      if (!usr || usr.length < 1) {
        return null;
      }
      let result = null;
      for (let index = 0; index < usr.length; index++) {
        const element = usr[index];
        const usrInmu = JSON.stringify(element.data);
        const usrAll = JSON.stringify(this.totalUsers.filter(i => i.id === element.id)[0].data);
        if (usrInmu != usrAll) {
          // result.push(element);
          result = element.id;
          break;
        }
      }
      return result;
    }, */
    /* totalUsers_old() {
      if (!this.datos || !this.datos.users) {
        return null;
      }
      let data = JSON.parse(JSON.stringify(this.datos.users));
      if (this.coPropietarios && this.coPropietarios.length > 0) {
        this.coPropietarios.forEach(element => {
          data.push(element);
        });
      }
      return data;
    }, */
    usersFormated() {
      if (!this.allUsers || !this.usuariosInmueble || this.usuariosInmueble < 1) {
        return [];
      }
      // const usersInmueble = this.usuariosInmueble;
      return this.usuariosInmueble.map(i => {
        const dataUsuario = this.allUsers.filter(a => a.id === i.id || a.uid === i.id)[0];
        const ncompleto = this.nombreCompleto(dataUsuario);
        return {
          nombre: ncompleto,
          // discapacidad: dataUsuario.discapacidad.isDiscapacidad, //discapacidad.isDiscapacidad 
          cuota: i.data.cuota,
          empadronado: i.data.empadronado,
          padronStatusConocido:  i.data.padronStatusConocido,
          tipo: i.data.tipo,
          volante: i.data.volante,
          id: i.id
        }
      });
      // return this.usuarios.map(i => {
      /* return this.allUsers.map(i => {
        let dataUsuario = usersInmueble.filter(a => a.id === i.id || a.id === i.uid).map(d => d.data)[0];
        if (!dataUsuario) {
          dataUsuario = {
            cuota: 0,
            empadronado: false,
            padronStatusConocido: false,
            tipo: false,
            volante: false
          }
        }
        let ncompleto = !!i.nombre || !!i.apellido1 || !!i.apellido2;
        ncompleto = ncompleto ? `${i.nombre} ${i.apellido1} ${i.apellido2}` : 'Sin especificar';
        ncompleto = ncompleto.replace(/undefined/g, '').trim();
        return {
          nombre: ncompleto,
          discapacidad: i.discapacidad.isDiscapacidad, //discapacidad.isDiscapacidad 
          cuota: dataUsuario.cuota,
          empadronado: dataUsuario.empadronado,
          padronStatusConocido: dataUsuario.padronStatusConocido,
          tipo: dataUsuario.tipo,
          volante: dataUsuario.volante,
          id: i.id
        }
      }); */
    },
    usersFormated_old() {
      return [];
      /* if (!this.datos || !this.datos.users) {
        return []
      }
      let data = JSON.parse(JSON.stringify(this.datos.users));
      if (this.coPropietarios && this.coPropietarios.length > 0) {
        this.coPropietarios.forEach(element => {
          data.push(element);
        });
      } */
      if (!this.usuarios) {
        return [];
      }
      return this.usuarios.map(i => {
        const dataUser = i.dataUser || {};
        let ncompleto = !!dataUser.nombre || !!dataUser.apellido1 || !!dataUser.apellido2;
        ncompleto = ncompleto ? `${dataUser.nombre} ${dataUser.apellido1} ${dataUser.apellido2}` : 'Sin especificar';
        ncompleto = ncompleto.replace(/undefined/g, '').trim();
        return {
          nombre: ncompleto,
          discapacidad: dataUser.discapacidad.isDiscapacidad, //discapacidad.isDiscapacidad 
          cuota: i.cuota,
          empadronado: i.empadronado,
          padronStatusConocido: i.padronStatusConocido,
          tipo: i.tipo,
          volante: i.volante,
          id: i.id
        }
      });
    }
  },
  methods: {
    ...mapActions(["saveDataUser", "setMunicipios", "setPropietarioDialog", "newPropietario", "setCoPropietarios", "deleteCoPropietario", "addCoPropInmueble", "despropiaCoProp", "saveDataInmuebleUser", "updateInmueble", "setFirmas", "actDesFirma"]),
    ingresosCalc() {
      // A) La suma de todos los ingresos de todos los empadronados > 16 años => < 3xIPREM (22.558) en General para obtener ayuda complementaria del 35%.

      // B) Andalucía: suma de ingresos del 50% de los empadronados > 16 años => < 5,5xIPREM (41.250)

      // ejemplo: Edif con 10 viviendas
      // requisitos -- Para obtener cualquier ayuda (40% sobre el importe del presupuesto del edificio):
      // - Al menos 5 viviendas con personas empadronadas 
      // - B) Andalucía esas 5 viviendas tengan menos de 5.5xIPREM

      // requisitos -- para las ayudas individuales
      // - A)


      // Requisitos Volante de empadronamiento:
      // - Andalucía, Madrid => Casilla autorización CCAA a consultarlo
      // - Valencia => Sólo saber si está o no empadronado. No tiene que enviar ni autorizar nada (Se justifica con el cert. ocupacional a nivel del edificio expedido por el Ayto.)
      // - Murcia => Subir o enviarnos el Volante de empadronamiento COLECTOVO de la vivienda a efectos de solicitar la ayuda o autorización expresa a GA para que se lo pidamos.

    },
    changeStatusFirma(idx, valor) {
      this.actDesFirma({
        id: idx,
        isActive: valor
      });
    },
    gestionarFrima(idx, nombre) {
      const cp = idx === this.getUserUid ? '' : `?cp=${idx}`;
      const dataUser = {
        nombre: nombre,
        id: idx,
        link: `${this.ruta}/firma/${this.getUserUid}${cp}`,
        firma2user: this.firma2user(idx)
      };
      this.gestionFirmaData = dataUser;
      this.dialogGestionFirma = true;
    },
    firma2user(uid) {
      if (!this.firmas || this.firmas.length < 1 || !uid) {
        return false
      }
      return this.firmas.filter(i => i.id === uid)[0]
    },
    saveInmueble() {
      console.log(`Guardar inmuebleData: ${this.refCat}`);
      this.updateInmueble(this.datos.inmuebleData);
    },
    changeIprem3() {
      if(this.datos.inmuebleData.iprem3 && this.iprem55Visible) {
        this.datos.inmuebleData.iprem55 = true;
      }
    },
    coPropietariosNum() {
      return this.coPropietarios ? this.coPropietarios.length : 0;
    },
    saveChangeUser(id) {
      console.log(`guardar cambios en: ${id}`);
      this.saveDataInmuebleUser({id: id, inmueble: this.refCat, data: this.usuariosInmueble.filter(i => i.id === id)[0].data});
    },
    nombreCompleto(i) {
      if (!i) {
        return 'Sin especificar';
      }
      let ncompleto = !!i.nombre || !!i.apellido1 || !!i.apellido2;
      ncompleto = ncompleto ? `${i.nombre} ${i.apellido1} ${i.apellido2}` : 'Sin especificar';
      ncompleto = ncompleto.replace(/undefined/g, '').trim();
      return ncompleto;
    },
    userDelete(id) {
      // Chequea si pertenece a algún otro inmueble
      console.log(`Eliminar co-propietario id: ${id}`);
      // Borrado directo en caso de cancelar los datos de un nuevo copropietario
      if (this.newUserAdded && this.newUserAdded === id) {
        this.deleteCoPropietario({ id: id, inmueble: this.refCat });
        return;
      }
      const user = this.coPropietarios.filter(i => i.id === id)[0];
      console.log(user);
      if (!user) {
        return;
      }
      const inmueblesList = user.dataUser.inmueblesList.filter(i => i != this.refCat);
      if (inmueblesList.length > 0) {
        this.despropiaCoProp({id: id, inmueble: this.refCat});
      } else {
        this.deleteConfirm = {
          title: 'Eliminar propietario/inquilino',
          text: 'Esta operación eliminará todos los datos del propietario o inquilino seleccionado, de manera permanente. Si es lo que desea, confirme presionando el botón "Eliminar". En caso contrario cancele esta operación',
          info: id,
          action: 'coPropietario',
          dialog: true
        };
        // this.deleteCoPropietario(id);
      }
    },
    userEdit(id) {
      console.log(`Editar id: ${id}`);
      if (this.newUserAdded && this.newUserAdded != id) {
        this.newUserAdded = null;
      }
      /* let index = -1;
      for (let count = 0; count < this.usuariosInmueble.length; count++) {
        const element = this.usuariosInmueble[count];
        if (element.id === id) {
          index = count;
          break;
        }
      }
      if (index < 0) {
        console.log("No encuentro al usuario");
        return;
      }
      this.usuarioSelect = this.usuarios[index]; //.filter(i => i.id === id)[0] // .dataUser;
      this.usuarioSelect.id = id; */
      const select = this.usuarios.filter(i => i.id === id)[0];
      if (!select) {
        console.log('No existe este usuario...');
        return;
      }
      this.usuarioSelect = select;
      this.setPropietarioDialog({
        dialog: 'formProfileInmueble',
        value: true
      });
    },
    changePropietario(id) {
      const user = this.usersFormated.filter(i => i.id === id)[0]
      let result = 0;
      if (user.tipo === '0') {
        result = 100;
      }
      this.usuariosInmueble.filter(i => i.id === id)[0].data.cuota = result;
    },
    nuevoUsuario() {
      console.log('agregar nuevo usuario');
      if (this.coPropNotUsed.length > 0) {
        this.dialogNewUser = true;
      } else {
        this.newPropietario(this.refCat);
      }
    },
    reutilizarCoPropFunc(id) {
      console.log('reutilizando co-propietario', id);
      if (!id) {
        return;
      }
      console.log('Enviando a ACTIONS', id);
      this.addCoPropInmueble({inmueble: this.refCat, id: id});
      this.dialogNewUser = false;
      /* setTimeout(() => {
        
      }, 500); */
    },
    crearCoProp() {
      this.newPropietario(this.refCat);
      this.dialogNewUser = false;
    },
    confirmDelete(action) {
      console.log(action);
      switch (action) {
        case 'coPropietario':
          this.deleteCoPropietario({ id: this.deleteConfirm.info, inmueble: this.refCat });
          break;
      
        default:
          break;
      }
      this.deleteConfirm = {
        title: '',
        text: '',
        info: null,
        action: '',
        dialog: false
      };
    }
  }
};
</script>

<style scoped>
.new-user {
  cursor: pointer;
}
.new-user:hover {
  color: rgb(79, 157, 180) !important;
}
</style>
